export const isValidCPF = (cpf: string) => {
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false;
  
  const values = cpf.split('').map(el => parseInt(el));
  const rest = (count: number) => (values.slice(0, count - 12).reduce((soma, el, index) => (soma + el * (count - index)), 0) * 10) % 11 % 10;
  
  return rest(10) === values[9] && rest(11) === values[10];
};

export const isValidEmail = (email: string) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

export const isValidPhone = (phone: string) => {
  const clean = phone.replace(/\D/g, '');
  return clean.length === 10 || clean.length === 11;
};

export const isValidCRM = (crm: string) => {
  const clean = crm.replace(/\D/g, '');
  return clean.length >= 4 && clean.length <= 10;
};
